// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";
import * as Body$BenfaerberBlog from "./blocks/Body.bs.js";
import * as Logo$BenfaerberBlog from "./components/Logo.bs.js";
import * as Theme$BenfaerberBlog from "./components/Theme.bs.js";
import * as Browser$BenfaerberBlog from "./wrappers/Browser.bs.js";
import * as BlogPage$BenfaerberBlog from "./pages/BlogPage.bs.js";
import * as AppContext$BenfaerberBlog from "./AppContext.bs.js";
import * as AboutMePage$BenfaerberBlog from "./pages/AboutMePage.bs.js";
import * as ArticlePage$BenfaerberBlog from "./pages/ArticlePage.bs.js";
import * as Translation$BenfaerberBlog from "./Translation.bs.js";
import * as Error404Page$BenfaerberBlog from "./pages/Error404Page.bs.js";
import * as ProjectsPage$BenfaerberBlog from "./pages/ProjectsPage.bs.js";

function getItemWithDefault(k, d) {
  return Belt_Option.getWithDefault(Caml_option.null_to_opt(localStorage.getItem(k)), d);
}

function setItem(k, v) {
  localStorage.setItem(k, v);
}

function unit(param) {
  
}

function App(props) {
  var getInitialContext = function () {
    var language = Translation$BenfaerberBlog.languageFromString(getItemWithDefault("language", "en"));
    return {
            logo: Logo$BenfaerberBlog.fromString(getItemWithDefault("logo", "crab")),
            theme: Theme$BenfaerberBlog.fromString(getItemWithDefault("theme", "light")),
            language: language,
            translate: (function (text) {
                return Translation$BenfaerberBlog.translateTo(language, text);
              }),
            setLogo: unit,
            setTheme: unit,
            setLanguage: unit
          };
  };
  var match = React.useState(getInitialContext);
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          var match = state.theme;
          if (match === "Light") {
            Browser$BenfaerberBlog.$$Document.removeHtmlClass("dark-mode");
          } else {
            Browser$BenfaerberBlog.$$Document.addHtmlClass("dark-mode");
          }
          var setLogo = function (logo) {
            setItem("logo", Logo$BenfaerberBlog.toString(logo));
            setState(function (s) {
                  return {
                          logo: logo,
                          theme: s.theme,
                          language: s.language,
                          translate: s.translate,
                          setLogo: s.setLogo,
                          setTheme: s.setTheme,
                          setLanguage: s.setLanguage
                        };
                });
          };
          var setTheme = function (theme) {
            setItem("theme", Theme$BenfaerberBlog.toString(theme));
            setState(function (s) {
                  return {
                          logo: s.logo,
                          theme: theme,
                          language: s.language,
                          translate: s.translate,
                          setLogo: s.setLogo,
                          setTheme: s.setTheme,
                          setLanguage: s.setLanguage
                        };
                });
          };
          var setLanguage = function (language) {
            setItem("language", Translation$BenfaerberBlog.languageToString(language));
            var translate = function (text) {
              return Translation$BenfaerberBlog.translateTo(language, text);
            };
            setState(function (s) {
                  return {
                          logo: s.logo,
                          theme: s.theme,
                          language: language,
                          translate: translate,
                          setLogo: s.setLogo,
                          setTheme: s.setTheme,
                          setLanguage: s.setLanguage
                        };
                });
          };
          setState(function (s) {
                return {
                        logo: s.logo,
                        theme: s.theme,
                        language: s.language,
                        translate: s.translate,
                        setLogo: setLogo,
                        setTheme: setTheme,
                        setLanguage: setLanguage
                      };
              });
        }), [state.theme]);
  return JsxRuntime.jsx(ReactRouterDom.HashRouter, {
              children: JsxRuntime.jsx(AppContext$BenfaerberBlog.Provider.make, {
                    value: state,
                    children: JsxRuntime.jsx(Body$BenfaerberBlog.make, {
                          children: JsxRuntime.jsxs(ReactRouterDom.Routes, {
                                children: [
                                  JsxRuntime.jsx(ReactRouterDom.Route, {
                                        path: "/",
                                        element: JsxRuntime.jsx(AboutMePage$BenfaerberBlog.make, {})
                                      }),
                                  JsxRuntime.jsx(ReactRouterDom.Route, {
                                        path: "blog",
                                        element: JsxRuntime.jsx(BlogPage$BenfaerberBlog.make, {})
                                      }),
                                  JsxRuntime.jsx(ReactRouterDom.Route, {
                                        path: "blog/:slug",
                                        element: JsxRuntime.jsx(ArticlePage$BenfaerberBlog.make, {})
                                      }),
                                  JsxRuntime.jsx(ReactRouterDom.Route, {
                                        path: "about-me",
                                        element: JsxRuntime.jsx(AboutMePage$BenfaerberBlog.make, {})
                                      }),
                                  JsxRuntime.jsx(ReactRouterDom.Route, {
                                        path: "projects",
                                        element: JsxRuntime.jsx(ProjectsPage$BenfaerberBlog.make, {})
                                      }),
                                  JsxRuntime.jsx(ReactRouterDom.Route, {
                                        path: "projects/:slug",
                                        element: JsxRuntime.jsx(ProjectsPage$BenfaerberBlog.make, {})
                                      }),
                                  JsxRuntime.jsx(ReactRouterDom.Route, {
                                        path: "*",
                                        element: JsxRuntime.jsx(Error404Page$BenfaerberBlog.make, {})
                                      })
                                ]
                              })
                        })
                  })
            });
}

var $$Storage;

var make = App;

export {
  $$Storage ,
  getItemWithDefault ,
  setItem ,
  unit ,
  make ,
}
/* react Not a pure module */
